export const TagPill = ({ tag }: { tag: string }) => (
  <p className="rounded-md text-primary-800 bg-primary-50 ring-primary-600/20 whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset">
    {tag}
  </p>
);
